import  { api } from "@/services/api";
import { mapMutations, mapState, mapGetters } from "vuex";

export const locationMixins = {
  data: () => ({
    locationGps: {
      longitud: "",
      latitud: ""
    },
    citysGhost: [],
    alertPolygon: false,
    address: "",
    placeFound: { place_id: null },
    city: null,
    zones: [],
    loading: false
  }),
  computed: {
    ...mapState('order',["purchaseId","shoppingCart"]),
    ...mapState('profile', ["session","location","place","supplierAvailability"]),
    ...mapState('customer', ["instance", "polygon","supplier"]),
    ...mapState('shared', [ "mainCategoryId" ]),
    ...mapState('delivery', [ "zone","citys","cutleryStore","packedStore" ]),
    ...mapGetters('customer', ["getLabels","price_currency_locale"])
  },
  methods: {
    ...mapMutations('customer', ["SetPolygon", "SetSupplier"]),
    ...mapMutations('profile', ["setLocation", "setPlace","setSupplierAvailability"]),
    ...mapMutations('order', ['setShoppingCart']),
    ...mapMutations('shared', ['setCoupon']),
    ...mapMutations('delivery', ['setZone','setCitys']),
    async validateLocation() {
      try {
        this.setDataLocation();
        const responseSupplierAvailability = await api.getSupplierAvailable();
        if (responseSupplierAvailability) {
          this.SetPolygon(responseSupplierAvailability.data.polygon);
          this.setSupplierAvailability({
            selected: true,
            data: responseSupplierAvailability.data
          });
          this.getInfoSucursal(responseSupplierAvailability.data.supplier_id);
          this.loading = false;
        };
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.alertPolygon = true;
      };
    },
    async getInfoSucursal(supplier_id) {
      try {
        const response = await api.getInfoSucursal(supplier_id);
        if (response) {
          this.zones = response.data.shipping_price;
          this.SetSupplier(response.data);
          this.setDataLocation();
        };
      } catch (error) {
        console.error(error);
        this.alertPolygon = true;
      };
    },
    async getCitys() {
      try {
        const response = await api.getCitys();
        if (response) {
          this.citysGhost = response.data;
          this.setCitys(response.data);
          if (!this.city && this.supplierAvailability.data && this.supplierAvailability.data.ciudad_id) this.city = this.citys.find(element => element.id === this.supplierAvailability.data.ciudad_id);
        };
      } catch (error) {
        console.error(error);
      };
    },
    setDataLocation() {
      this.setLocation({
        latitude: this.locationGps.latitud ,
        longitude: this.locationGps.longitud,
        address: this.address,
        address_optional: this.infoOpcional,
        optional: this.infoOpcional,
        addressSetUser: this.address,
        formatted_address: this.place?.formatted_address,
        city: this.city,
        place_id: this.place?.place_id,
        location_price: (this.polygon !== null && this.polygon.polygon_found !== null || this.zone !== null) ? (this.polygon?.delivery_price || this.zone?.value) : null,
        supplier_id: this.supplier ? this.supplier.id : null,
        polygon_id: this.polygon !== null && this.polygon.active ? this.polygon.id : null
      });
    }
  }
}